import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import Team from "./Team";

function Teamshow() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, []);

  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  if (!loading) {
    return <div></div>;
  }
  return (
    <div ref={ref} className={`box ${inView ? "actives" : ""}`}>
      <Team />
    </div>
  );
}
export default Teamshow;
